import { appConfig } from '$utils'
import { QueryOptions } from '@tanstack/react-query'
import api from './api'

/**
 * Execute a GET query against Web Api.
 *
 * @param path the path of endpoint
 * @param options QueryOptions from React Query (without queryKey and queryFn)
 * @param signal to be able to abort the api call
 * @returns the data parsed from the JSON response received
 */
async function get<T>(
  path: string,
  options?: Omit<QueryOptions<T>, 'queryKey' | 'queryFn'>,
  signal?: AbortSignal
) {
  return await api.get(appConfig.get<string>('apiUrl'), path, options, signal)
}

/**
 * Execute a POST against Web Api.
 *
 * @param path the path of the endpoint
 * @param requestBody the body of the POST request
 * @param signal to be able to abort the api call
 * @returns the data parsed from the JSON response received
 */
async function add(path: string, requestBody: object, signal?: AbortSignal) {
  return await api.add(
    appConfig.get<string>('apiUrl'),
    path,
    requestBody,
    signal
  )
}

/**
 * Execute a PUT against Web Api.
 *
 * @param path the path of the endpoint
 * @param requestBody the body of the PUT request
 * @param signal to be able to abort the api call
 * @returns the data parsed from the JSON response received
 */
async function update(path: string, requestBody: object, signal?: AbortSignal) {
  return await api.update(
    appConfig.get<string>('apiUrl'),
    path,
    requestBody,
    signal
  )
}

/**
 * Execute a DELETE agaisnt Web Api.
 *
 * @param path the path of the endpoint
 * @param requestBody the body of the DELETE request
 * @param signal to be able to abort the api call
 * @returns the data parsed from the JSON response received
 */
async function remove(
  path: string,
  requestBody?: object,
  signal?: AbortSignal
) {
  return await api.remove(
    appConfig.get<string>('apiUrl'),
    path,
    requestBody,
    signal
  )
}

export default {
  get,
  add,
  update,
  remove,
}
